// This file contains the shared default values for all environments
// The individual values can be specifically overwritten for each environment

export const defaultEnvironment = {
  app_name: 'homepage',
  auth_header_name: 'authorization',
  file_download_auth_name: 'X-Auth-Token',
  ftp_port: '2222'
};
